import { useId, useState } from 'react';
import { Button, Collapse, Empty, Flex, Skeleton } from 'antd';
import { useGetAuditLogs } from 'api/audit-logs/use-get-audit-logs.ts';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { AuditLogsList } from './components/audit-logs-list';
import styles from './entity-audit-logs.module.scss';
import type { IAuditEntityContext } from './types';

const EntityAuditLogsComponent: React.FC<IAuditEntityContext> = (props) => {
  const { entityType, entityId } = props;

  const panelId = useId();
  const [isOpen, setIsOpen] = useState(false);

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isInitialLoading } = useGetAuditLogs({
    entityType,
    entityId,
    enabled: isOpen,
  });

  const auditLogs = data?.pages.flatMap((page) => page.data) || [];
  const currentEntity = { entityType, entityId };

  const handleCollapseChange = (key: string | string[]) => {
    setIsOpen(!!key.length);
  };

  return (
    <Collapse className={styles.collapse} onChange={handleCollapseChange}>
      <Collapse.Panel key={panelId} header='Audit logs'>
        <Skeleton loading={isInitialLoading} active>
          {auditLogs.length ? (
            <>
              <AuditLogsList auditLogs={auditLogs} currentEntity={currentEntity} />
              {hasNextPage ? (
                <Flex className={styles.loadMore} justify='center'>
                  <Button loading={isFetchingNextPage} onClick={() => fetchNextPage()}>
                    Load more
                  </Button>
                </Flex>
              ) : null}
            </>
          ) : (
            <Empty
              className={styles.empty}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description='No audit logs available'
            />
          )}
        </Skeleton>
      </Collapse.Panel>
    </Collapse>
  );
};

export const EntityAuditLogs = withRoleGuard(EntityAuditLogsComponent, [UserRole.admin, UserRole.assistant]);
